import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import SpecCheckPluginContainer from '../@shared/specCheckPluginContainer';
import { SpecCheckPluginModel } from '../@shared/specCheckPluginContainer/models/specCheckPlugin.model';
import { TSpecCheckPluginProps } from '../@shared/specCheckPluginContainer/types/specCheckPlugin.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';

const ProductModelDetailSpecCheck: FC<TSpecCheckPluginProps> = (props) => {
  const model = new SpecCheckPluginModel(props);
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const apiResponse = isEmptyResponse(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  if (!model?.embedId) {
    return isEditorActive() ? <EmptyApiDataMessage componentName={model.componentName} /> : <></>;
  }

  return <SpecCheckPluginContainer embedId={model?.embedId} />;
};

export default ProductModelDetailSpecCheck;
